import React from "react";

/**
 * Laredo Backflow LLC — shield/badge logo
 * Blue-collar plumber vibe: hexagonal badge, valve cross, bold wordmark.
 */
export default function Logo({ size = 40, withText = true, theme = "light" }) {
  const inkColor = theme === "light" ? "#0F172A" : "#FFFFFF";
  const subColor = theme === "light" ? "#64748B" : "#94A3B8";

  return (
    <div className="flex items-center gap-3">
      <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Laredo Backflow LLC"
      >
        {/* Hex badge */}
        <path
          d="M32 2 L58 17 L58 47 L32 62 L6 47 L6 17 Z"
          fill="#0F172A"
          stroke="#0F172A"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        {/* Inner hex stripe */}
        <path
          d="M32 8 L52 20 L52 44 L32 56 L12 44 L12 20 Z"
          fill="none"
          stroke="#FF5A1F"
          strokeWidth="1.6"
          strokeLinejoin="round"
        />
        {/* Horizontal pipe */}
        <rect x="10" y="29" width="44" height="6" fill="#0066FF" />
        {/* Pipe flanges */}
        <rect x="10" y="27" width="3" height="10" fill="#FFFFFF" />
        <rect x="51" y="27" width="3" height="10" fill="#FFFFFF" />
        {/* Center valve body */}
        <rect x="26" y="23" width="12" height="18" fill="#FFFFFF" stroke="#0F172A" strokeWidth="1.2" />
        {/* Valve stem */}
        <rect x="31" y="14" width="2" height="10" fill="#FFFFFF" />
        {/* Valve wheel */}
        <circle cx="32" cy="12" r="5" fill="none" stroke="#FF5A1F" strokeWidth="2" />
        <line x1="27" y1="12" x2="37" y2="12" stroke="#FF5A1F" strokeWidth="2" />
        <line x1="32" y1="7" x2="32" y2="17" stroke="#FF5A1F" strokeWidth="2" />
        {/* Drop inside body */}
        <path d="M32 28 C30 31 29 33 29 35 A3 3 0 0 0 35 35 C35 33 34 31 32 28 Z" fill="#0066FF" />
        {/* Corner rivets */}
        <circle cx="11" cy="21" r="1.2" fill="#FF5A1F" />
        <circle cx="53" cy="21" r="1.2" fill="#FF5A1F" />
        <circle cx="11" cy="43" r="1.2" fill="#FF5A1F" />
        <circle cx="53" cy="43" r="1.2" fill="#FF5A1F" />
      </svg>

      {withText && (
        <div className="flex flex-col leading-none">
          <span
            className="font-display font-extrabold text-[17px] tracking-tight"
            style={{ color: inkColor }}
          >
            LAREDO <span style={{ color: "#0066FF" }}>BACKFLOW</span>
          </span>
          <span
            className="text-[10px] tracking-[0.28em] font-display font-semibold mt-0.5"
            style={{ color: subColor }}
          >
            LLC · CERTIFIED SINCE 2016
          </span>
        </div>
      )}
    </div>
  );
}
